<style lang="scss" scoped>
.upload {
	&__pad-bottom {
		margin-bottom: 30px;
	}
	&__text {
		padding: 20px;
		text-align: center;
	}

	&__header {
		@include flex-center;
		&__buttons {
			margin-left: auto;
			> button, div {
				margin-left: 15px;
			}
		}
	}
}

.padding {
	padding: 20px 40px;
}
.progress-bar {
	margin: 40px 0px 0px 0px;
}
.content {
	margin-top: 20px;
}
</style>

<template lang="pug">
.upload
	org-app-header
		.upload__header(slot="header")
			h1.upload__header__title {{ providerName }} School Manager Sync
			.upload__header__buttons
				el-button(type="success", @click="download", icon='fe fe-download fe-just-off', :loading="csvLoading || !updatedCache").ml-auto Download
				el-button(type="primary", @click="upload", icon='fe fe-repeat fe-just-off', :loading="loading && !workCompleted").ml-auto Sync
	.container
		.main-panel
			div.padding(v-if="!loading")
				p
					| Wonde will perform sync to {{ providerFullName }}. You may download your organisation data and review it to ensure everything is in place. Click <b>Sync</b> to proceed.
			div(v-if="loading && !workCompleted")
				loading(:message="progress && progress.meta.progress ? [progress.meta.progress] : loadingMessage")
					el-progress.progress-bar(:percentage="progress && progress.meta.percent ? progress.meta.percent : 0", :text-inside="true", :stroke-width="18", text-color="#fff")
			empty(:message="emptyMessage", v-if="workCompleted & !failedUploadMessage")
				div.content(slot="content")
					el-button(type="primary" @click="openASM") {{ providerName }} School Manager
			empty(:message="failedUploadMessage", v-if="workCompleted && failedUploadMessage")

</template>

<script>
import gql from "graphql-tag";
import Bugsnag from '@bugsnag/js';
export default {
	data() {
		return {
			loading: false,
			loadingMessage: [`Fetching data...`],
			emptyMessage: "",
			uuid: "",
			work: null,
			csvLoading: false,
			updatedCache: true,
			school: {
				Organisation: null
			}
		};
	},
	apollo: {
		work: {
			query: gql`
				query GetWorks($where: WorkWhereInput, $order: WorkOrderByInput) {
					Work(where: $where, order: $order) {
						uuid
						payload
					}
				}
			`,
			variables() {
				return {
					where: {
						uuid: this.uuid,
						type: "organisation"
					}
				};
			},
			update: r => _.cloneDeep(r.Work),
			pollInterval: 3000,
			fetchPolicy: "no-cache",
			skip() {
				return this.workCompleted || !this.uuid;
			},
		},
		csv: {
			query: gql`
				query DownloadOrgData {
					DownloadOrgData {
						content
					}
				}
			`,
			update(r) {
				if(r.DownloadOrgData && !_.isNil(r.DownloadOrgData.content)) {
					this.csvLoading = false;
					const linkSource = `data:application/zip;base64,${r.DownloadOrgData.content}`;
					let downloadLink = document.createElement("a");
					downloadLink.href = linkSource;
					downloadLink.download = `AppleSchoolManager.zip`;
					downloadLink.click();
				}
				return _.cloneDeep(r.DownloadOrgData)
			},
			pollInterval: 5000,
			fetchPolicy: "no-cache",
			skip() {
				return !this.csvLoading || !this.updatedCache;
			},
		},
		school: {
			query: gql`
				{
					School {
						Organisation {
							id
							name
						}
					}
				}
			`,
			update: (r) => r.School,
		},
	},
	computed: {
		progress() {
			if (this.work && this.work.length) {
				try {
					return JSON.parse(this.work[0].payload)
				} catch (e) {
					Bugsnag.notify(e);
					return null;
				}
			} 
			return null;
		},
		workCompleted() {
			return !_.isNil(this.progress) && this.progress.meta.percent === 100;
		},
		failedUploadMessage() {
			return this.workCompleted && this.progress.meta.progress.includes("error") ? this.progress.meta.progress : "";
		}
	},
	methods: {
		async upload() {
			this.work = null;
			this.loading = true;

			try {
				const uploaded = await this.$apollo
					.mutate({
						mutation: gql`
							mutation UploadOrgDataMutation {
								UploadOrgDataMutation
							}
						`,
					});
				this.uuid = uploaded.data.UploadOrgDataMutation;
				this.emptyMessage = `Uploading MIS/SIS data is complete but sync process may take a while. Open ${this.providerName} School Manager to check status.`;
			} catch (e) {
				Bugsnag.notify(e);
				this.emptyMessage = "Failed to upload MIS/SIS data, please contact support if issue continues.";
			}
		},
		async download() {
			await this.cacheClear();
			this.csvLoading = true;
		},
		async cacheClear() {
			this.updatedCache = false;
			await this.$apollo.mutate({
				mutation: gql`
					mutation CacheClear($item: CacheTypeEnum!, $type: String!) {
						CacheClear(item: $item, type: $type)
					}`,
					variables: {	
						item: "csv",
						type: "organisation"
						
					}
			},);
			this.updatedCache = true;
		},
		openASM() {
			window.open("https://school.apple.com", "_blank");
		}
	}
};
</script>
